export const size = ['16 – 17 inch', '18 inch', '19 inch', '20 inch & Above']
